const questions = [
    {
        id: 1,
        title: 'Est ce que cette application est destinée seulement au étudiants de  l Esi ?',
        description: 'Oui, pour vous connecter a notre application et avoir acces au modules et cours disponible sur TalentEsi, vous devez vous authentifier avec votre mail (@esi.dz).'
    },
    {
        id: 2,
        title: 'Quelques modules ne contiennent pas de cours, Est ce normal ?',
        description: 'Il est possible que vous trouvez certains modules vide, soit ceux ci sont vides aussi sur TalentEsi, ou que leur stockage dans le site a ete fait d une maniere assez spéciale qui n a pas été traitée par notre systeme, Vous pouvez les rajouter manuellement en cliquant sur "Ajouter un nouveau cours". '
    },
    {
        id: 3,
        title: 'Les boutons pour effectuer des modifications dans l outil ne marche pas ?',
        description: 'Si les boutons pour modifier ne marchent pas, veuillez vous assurer que vous avez d abord selectionné le noeud que sera affecter par celles ci.'
    },
    {
        id: 4,
        title: 'Est ce que je dois avoir acces a internet pour utiliser l application ?',
        description: 'Pour l authentification et l exportation, oui. Vous devez avoir acces a Internet pour connecter votre mail, mais une fois cette étape faite, vous pouvez utiliser notre application sans problemes de connexion, car tout ce qui suit (mocules, cours, notions du cours, sauvegarde des cartes mentales,...) se fait a partir d un systeme de gestion de donnée performant (Base de données, fichiers locaux,...) accessible a tout moment.'
    }

]

export default questions;